function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "89.712%",
  y2: "95.911%",
  id: "arrow-right_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#67DBC3",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2E648A",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "url(#arrow-right_svg__a)",
  strokeWidth: 2,
  x: 1,
  y: 1,
  width: 34,
  height: 34,
  rx: 17
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.072 25.4l-.672-.642 6.653-6.358-6.653-6.358.672-.642 6.989 6.679a.44.44 0 010 .642L15.07 25.4z",
  fill: "#1B7E8D",
  fillRule: "nonzero",
  stroke: "#1B7E8D"
}));

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzNiI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgeDE9IjAlIiB5MT0iMCUiIHgyPSI4OS43MTIlIiB5Mj0iOTUuOTExJSIgaWQ9ImEiPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjNjdEQkMzIiBvZmZzZXQ9IjAlIi8+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMyRTY0OEEiIG9mZnNldD0iMTAwJSIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHN0cm9rZT0idXJsKCNhKSIgc3Ryb2tlLXdpZHRoPSIyIiB4PSIxIiB5PSIxIiB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHJ4PSIxNyIvPgogICAgPHBhdGggZD0iTTE1LjA3MiAyNS40bC0uNjcyLS42NDIgNi42NTMtNi4zNTgtNi42NTMtNi4zNTguNjcyLS42NDIgNi45ODkgNi42NzlhLjQ0LjQ0IDAgMDEwIC42NDJMMTUuMDcgMjUuNHoiIGZpbGw9IiMxQjdFOEQiIGZpbGwtcnVsZT0ibm9uemVybyIgc3Ryb2tlPSIjMUI3RThEIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgArrowRight as ReactComponent };